import React from 'react';
import './WpBubble.scss';

const WpBubble: React.FC<{}> = React.memo(() => {
    
    const openWp = () => {
        window.location.href = 'https://wa.me/541136945737';
    };

    return (
        <div 
            onClick={openWp}
            className="WpBubble">
            <span className="WpIcon"></span>
        </div>
    )
});

export default WpBubble;